// extracted by mini-css-extract-plugin
module.exports = {"mCard":"hg-z","image":"ig-z","imageNoBackground":"jg-z"};